import styled from "styled-components";

export const Div = styled.div`
	.container {
	}
	.availble-item {
		display: flex;
	}
	.description {
		display: flex;
		flex-direction: column;
		gap: 10px;
	}
	.icon {
		width: 14px;
		height: 14px;
		padding-top: 2px;
		margin-right: 10px;
	}
`;
export const TextLabel = styled.p`
	font-size: 0.875rem;
	font-weight: 400;
	line-height: 22px;
`;
